import { addToast as add, removeToast as remove } from '../toastNotifications'

export function createToast({ title, content, type = 'INFO', date = new Date() }) {
  const id = `${Date.now()}-${Math.random().toString(36).slice(2,8)}`
  return add({ id, title, content, read: false, type, date })
}

export function dismissToast(id) {
  return remove(id)
}



// WEBPACK FOOTER //
// ./src/redux/actions/toastNotifications.js